export var ManifestFormat;
(function (ManifestFormat) {
    ManifestFormat["FILE_URLS_MP3"] = "file_urls_mp3";
    ManifestFormat["FILE_URLS_EXTERNAL"] = "file_urls_external";
    ManifestFormat["FILE_IDS_MP4"] = "file_ids_mp4";
    ManifestFormat["FILE_IDS_MP4_DUAL"] = "file_ids_mp4_dual";
    ManifestFormat["FILE_IDS_CBCS"] = "file_ids_mp4_cbcs";
    ManifestFormat["MANIFEST_IDS_VIDEO"] = "manifest_ids_video";
})(ManifestFormat || (ManifestFormat = {}));
//# sourceMappingURL=manifest_format.js.map